<section style="padding-bottom: 3px;margin-top: 120px;">
    <div class="container" data-aos="fade-up">
        <div class="row">
            <div class="col-lg-12">
                <h1 class="theme_color">
                    <strong>Sign up now to get added to our mailing list! </strong>
                </h1>

                <p class="theme_color fontSize">
                    Once a month we send out the latest safety news to keep you and your crew up to date. 
                </p>

                <p class="theme_color fontSize">
                    <a href="https://visitor.r20.constantcontact.com/manage/optin?v=0017rDYctTjtbhpHTxBvvbPrdbMCpKVTALAHMl1Kd6ARZ3ut4m_I_5dAS0Ba0GRsYdPWr0EKA-U0cVqSVYFZa1fYGmfGSoS8l4SLImJWT82kDm-hifk4CfeVPlsp9Ga520POQFMK2VYN-6djPNOB0UEALfmi_NFJkfxzyPjSaPHQRAku9390UNYkqaEaq6R8TLf" target="_blank">Signup Form</a>
                </p>
            </div>
        </div>
    </div>
</section>
